import { OpenInFull } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import type { FC } from "react";

type Props = {
	onClick: () => void;
};

export const MaximizeButton: FC<Props> = ({ onClick }) => {
	const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.stopPropagation();
		onClick();
	};
	return (
		<Tooltip title={"Maximize"}>
			<IconButton data-testid="chart-maximize-button" size="small" onClick={(e) => handleClick(e)}>
				<OpenInFull fontSize="small" />
			</IconButton>
		</Tooltip>
	);
};
